export default [
  {
    name: "Volume (L15)",
    id: "volume",
    aggregated_data: [
      {
        name: "FAME",
        id: "volume_fame",
      },
      {
        name: "FAME(advanced)",
        id: "volume_fame_advanced",
      },
      {
        name: "HVO/HRO",
        id: "volume_hvo_hro",
      },
      {
        name: "HVO/HRO(advanced)",
        id: "volume_hvo_hro_advanced",
      },
      {
        name: "Etanol",
        id: "volume_etanol",
      },
      {
        name: "Etanol(advanced)",
        id: "volume_etanol_advanced",
      },
      {
        name: "Nafta",
        id: "volume_nafta",
      },
      {
        name: "Nafta(advanced)",
        id: "volume_nafta_advanced",
      },
      {
        name: "Biogasoline",
        id: "volume_biogasoline",
      },
      {
        name: "Biogasolie(advanced)",
        id: "volume_biogasoline_advanced",
      },
      {
        name: "Fossil",
        id: "volume_fossil",
      },
    ],
  },
  {
    name: "Energy content (MJ)",
    id: "energy_content_total",
    aggregated_data: [
      {
        name: "FAME",
        id: "energy_content_fame",
      },
      {
        name: "FAME(advanced)",
        id: "energy_content_fame_advanced",
      },
      {
        name: "HVO/HRO",
        id: "energy_content_hvo_hro",
      },
      {
        name: "HVO/HRO(advanced)",
        id: "energy_content_hvo_hro_advanced",
      },
      {
        name: "Etanol",
        id: "energy_content_etanol",
      },
      {
        name: "Etanol(advanced)",
        id: "energy_content_etanol_advanced",
      },
      {
        name: "Nafta",
        id: "energy_content_nafta",
      },
      {
        name: "Nafta(advanced)",
        id: "energy_content_nafta_advanced",
      },
      {
        name: "Biogasoline",
        id: "energy_content_biogasoline",
      },
      {
        name: "Biogasoline(advanced)",
        id: "energy_content_biogasoline_advanced",
      },
      {
        name: "Fossil",
        id: "energy_content_fossil",
      },
    ],
  },
  {
    name: "Emissions WTW (tCO2e)",
    id: "emission_total",
    aggregated_data: [
      {
        name: "FAME",
        id: "emission_fame",
      },
      {
        name: "FAME(advanced)",
        id: "emission_fame_advanced",
      },
      {
        name: "HVO/HRO",
        id: "emission_hvo_hro",
      },
      {
        name: "HVO/HRO(advanced)",
        id: "emission_hvo_hro_advanced",
      },
      {
        name: "Etanol",
        id: "emission_etanol",
      },
      {
        name: "Etanol(advanced)",
        id: "emission_etanol_advanced",
      },
      {
        name: "Nafta",
        id: "emission_nafta",
      },
      {
        name: "Nafta(advanced)",
        id: "emission_nafta_advanced",
      },
      {
        name: "Biogasoline",
        id: "emission_biogasoline",
      },
      {
        name: "Biogasoline(advanced",
        id: "emission_biogasoline_advanced",
      },
    ],
  },
  {
    name: "Fossil ref. (tCO2e)",
    id: "fossil_ton",
  },
  {
    name: "Emission red. (tCO2e)",
    id: "emission_reduction_total",
    aggregated_data: [
      {
        name: "FAME",
        id: "emission_reduction_fame",
      },
      {
        name: "FAME(advanced)",
        id: "emission_reduction_fame_advanced",
      },
      {
        name: "HVO/HRO",
        id: "emission_reduction_hvo_hro",
      },
      {
        name: "HVO/HRO(advanced)",
        id: "emission_reduction_hvo_hro_advanced",
      },
      {
        name: "Etanol",
        id: "emission_reduction_etanol",
      },
      {
        name: "Etanol(advanced)",
        id: "emission_reduction_etanol_advanced",
      },
      {
        name: "Nafta",
        id: "emission_reduction_nafta",
      },
      {
        name: "Nafta(advanced)",
        id: "emission_reduction_nafta_advanced",
      },
      {
        name: "Biogasoline",
        id: "emission_reduction_biogasoline",
      },
      {
        name: "Biogasoline(advanced)",
        id: "emission_reduction_biogasoline_advanced",
      },
    ],
  },
  {
    name: "Emission red. (%)",
    id: "emission_reduction_percentage",
  },
];
